import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnimationOvershoot: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="animation-overshoot"><path d="M3.76703 20.25C3.76703 20.25 3.2519 1.44501 7.88773 3.98615C12.5236 6.5273 14.584 7.03558 20.25 7.03558" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAnimationOvershoot;
